
let sButtons = document.querySelectorAll(".ccs-wrapper button")
sButtons.forEach(button => button.addEventListener('click', e => {
  let {size, id, option} = e.target.dataset
  let variants = JSON.parse(document.querySelector(`[type="application/product-${id}"]`).textContent)
  let currentVariant = variants.find(variant => variant[option] === size)
  customAddToCart(currentVariant.id)
}))


function customAddToCart(id) {
  let formData = {
   'items': [{
    'id': id,
    'quantity': 1
    }]
  };
  
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(response => {
    if(response.status) {
      alert(response.description)
    }else{
      new CartNotification().open()
      cartItemShow(response.items[0])
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
}

function cartItemShow(item){
  let options = ''
  item.options_with_values.forEach(o => {
    options += `<dt>${o.name}: </dt><dd>${o.value}</dd><br>`
  })
  let container = document.querySelector("#cart-notification-product")
  let content = `  <div class="cart-notification-product__image global-media-settings">
      <img src="${item.image}" alt="" width="70" height="93" loading="lazy">
      </div>
      <div>
        <h3 class="cart-notification-product__name h4">${item.title}</h3>
        <dl>
          <div class="product-option">
            ${options}
          </div>
        </dl>
      </div>`
  container.innerHTML = content
}

